import React from 'react';

const FinnishPage = () => {
    return (
        <div>
            <h3>
                <span lang="fi">Hyvä yliopiston opettaja!</span>
            </h3>
            <h3>
                <span lang="fi">
                    Tervetuloa käyttämään Reflektiokompassia tutkimusetiikan opetuksessa!
                </span>
            </h3>

            <p>
                <span lang="fi">
                    Reflektiokompassisovellus on suunniteltu tukemaan opettajia tutkimusetiikan
                    opetuksessa sekä tukemaan opiskelijoiden reflektiota tutkimusetiikan
                    oppimistehtävissä.{' '}
                </span>
            </p>

            <p>
                <span lang="fi">
                    Tutkimuseettisiä teemoja käsitellään monella opintojaksolla, esimerkiksi
                    tutkimusseminaareissa, menetelmäkursseilla, tieteellisen kirjoittamisen
                    kursseilla sekä vertaisarviointia ja julkaisemista käsittelevissä seminaareissa.
                    Lisäksi reflektio on tärkeä osa eettisen herkkyyden kehittymistä. Kun opettaja
                    haluaa tietää, mitä ja miten opiskelijat oppivat, tutkimusetiikan ja
                    reflektiotaitojen arviointi voi olla haastavaa. Opiskelijat saattavat turvautua
                    tekoälytyökaluihin tehtävien suorittamisessa, mikä on usein hyväksyttävää, mutta
                    jos se tehdään ilman omaa ajattelua ja reflektiota, on kyseenalaista, mitä
                    opiskelijat ovat todella oppineet. Opettajat saattavat toivoa voivansa välttää
                    ei-toivottua tekoälyn käyttöä samalla kun heillä säilyy yhteys opiskelijoiden
                    oppimisprosessiin ilman, että se edellyttää huomattavaa määrää tehtävien
                    tarkistamista.
                </span>
            </p>

            <h3>
                <span lang="fi">Mitä sovellus tekee? </span>
            </h3>

            <p>
                <span lang="fi">
                    Esittelemme tutkimuspohjaisen työkalun yliopisto-opettajille, jotka käsittelevät
                    tutkimusetiikkaa opetuksessaan. Sovelluksen ovat kehittäneet tutkimusetiikan
                    asiantuntijat ja pedagogit opettajan tueksi. Sovellus auttaa opettajaa{' '}
                </span>
            </p>

            <p>
                <span lang="fi">
                    •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </span>
                <span lang="fi">
                    selvittämään, mitä opiskelijat oppivat ja miten toimivaa opetus on;{' '}
                </span>
            </p>

            <p>
                <span lang="fi">
                    •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </span>
                <span lang="fi">
                    seuraamaan, miten opiskelijat ymmärtävät kurssilla käsiteltyjä tutkimusetiikan
                    sisältöjä;{' '}
                </span>
            </p>

            <p>
                <span lang="fi">
                    •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </span>
                <span lang="fi">
                    toteuttamaan formatiivista arviointia ja antamaan palautetta opiskelijoille
                    kurssin aikana;{' '}
                </span>
            </p>

            <p>
                <span lang="fi">
                    •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </span>
                <span lang="fi">
                    kannustamaan opiskelijoita pohtimaan oppimistaan ja tukemaan heidän
                    reflektiotaitojensa kehittymistä;{' '}
                </span>
            </p>

            <p>
                <span lang="fi">
                    •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </span>
                <span lang="fi">tukemaan opiskelijoita itsearviointitaitojen kehittämisessä.</span>
            </p>

            <h3>
                <span lang="fi">Miten sovellus toimii? </span>
            </h3>

            <p>
                <span lang="fi">
                    Sovellus ohjaa opettajaa luomaan kurssin, jossa on opiskelijan reflektiota
                    vaativia tehtäviä. Kurssin ja tehtävien luomisen jälkeen opettaja kopioi kutsun,
                    joka jaetaan opiskelijoille. Kurssiin kannattaa sisällyttää useita tehtäviä.
                    Niiden ajankohdan voi jaksottaa, ja sovellus ilmoittaa opiskelijalle, mikä
                    tehtävä on kulloinkin aktiivinen. Opettaja voi myös kopioida kurssejaan ja
                    tehtäviään ja käyttää niitä tulevina lukukausina (kursseilla on yksilölliset
                    tunnukset, jotka auttavat erottamaan toisistaan eri vuodet ja ryhmät).
                </span>
            </p>

            <p>
                <span lang="fi">
                    Opiskelijat kirjautuvat sisään tunnuksillaan ja voivat siirtyä tehtävään, jonka
                    opettaja on ilmoittanut kutsulinkissä. Opiskelijalle tehtävä sisältää kaksi
                    vaihetta. Ensin he pohtivat tehtävässä ilmoitettua aihetta kirjoittamalla
                    lyhyehkön tekstikappaleen tehtävän kuvauksen mukaisesti. Sen jälkeen he lukevat
                    viisi väitettä ja valitsevat sen, joka parhaiten kuvaa heidän ymmärrystään
                    aiheesta, josta juuri ovat kirjoittaneet. Lähetettyään vastauksensa, opiskelijat
                    saavat automaattisen palautteen, joka kuvaa sanallisesti heidän valitsemaansa
                    ymmärryksen tasoa. Sovellus kannustaa opiskelijoita pohtimaan, vastaako heidän
                    lähettämänsä teksti palautteessa kuvattua ymmärryksen tasoa. Opiskelijoilla on
                    mahdollisuus palata vastaukseensa ja muokata joko kirjoittamaansa kappaletta tai
                    valita toinen vaihtoehto kuvaamaan heidän ymmärryksensä tasoa.
                </span>
            </p>

            <p>
                <span lang="fi">
                    Sovellus analysoi opiskelijan itse arvioiman ymmärryksenä tason ja esittää
                    tulokset piirakkakaaviona opettajalle (katso kuvio 1).
                </span>
            </p>

            <p align="center">
                <span lang="fi">
                    <img
                        alt=">Kuvio 1. Opettajan näkymä suoritetuista tehtävistä."
                        width="500"
                        height="auto"
                        src="/image003.png"
                    />
                </span>
            </p>

            <p>
                <span lang="fi">Kuvio 1. Opettajan näkymä suoritetuista tehtävistä.</span>
            </p>

            <p>
                <span lang="fi">&nbsp;</span>
            </p>

            <p>
                <span lang="fi">
                    Sekä opettaja että opiskelijat voivat nähdä oppimisen edistymisen myös
                    lineaarisessa kaaviossa (katso kuvio 2).
                </span>
            </p>

            <p align="center">
                <span lang="fi">
                    <img
                        alt=" Kuvio 2. Lineaarinen kaavio opiskelijoiden edistymisestä (esimerkki kahden
                    tehtävän tuloksista)."
                        width="700"
                        height="auto"
                        src="/image004.png"
                    />
                </span>
            </p>

            <p>
                <span lang="fi">
                    Kuvio 2. Lineaarinen kaavio opiskelijoiden edistymisestä (esimerkki kahden
                    tehtävän tuloksista).
                </span>
            </p>

            <p>
                <span lang="fi">&nbsp;</span>
            </p>

            <p>
                <span lang="fi">
                    Opettaja voi myös lukea opiskelijoiden tuottamat tekstit ja antaa
                    henkilökohtaisempaa palautetta kirjoittamalla omin sanoin palautteen
                    opiskelijalle ja/tai valitsemalla valikosta sen ymmärryksen tason, jota
                    opiskelijan teksti opettajan arvion mukaan ilmentää.
                </span>
            </p>

            <p>
                <span lang="fi">
                    Sovelluksen käyttö tukee pääasiassa opiskelijoiden reflektiivistä oppimista ja
                    formatiivista arviointia kurssin aikana, mutta yksittäisen opiskelijan
                    oppimisprosessia kuvaava kaavio (kuvio 2) toimii hyvin perustana myöhemmälle
                    reflektiopäiväkirjalle, jos opettaja haluaa liittää sellaisen kurssiinsa. Kaavio
                    toimii pohjana ja inspiraationa opiskelijalle ja auttaa häntä analysoimaan
                    oppimisprosessiaan reflektiopäiväkirjassa. Reflektiopäiväkirjaa voidaan käyttää
                    summatiivisen arvioinnin tarkoituksiin, eli arvioitavana tehtävänä, jonka
                    perusteella muodostuu kurssin lopullinen arviointi, yleensä arvosana.
                </span>
            </p>

            <p>
                <span lang="fi">
                    Sovelluksen toistuva käyttö antaa opettajille tietoa siitä, miten opiskelijat
                    edistyvät, mitkä aiheet ovat hyvin hallussa ja mitkä ovat opiskelijoille
                    haastavampia. Opiskelijat voivat myös nähdä oman edistymisensä kaaviossa, ja
                    lukemalla sovelluksen ja opettajan antamaa palautetta he voivat kehittää
                    osaamistaan sekä reflektointi- ja itsearviointitaitojaan.
                </span>
            </p>

            <p>
                <span lang="fi">&nbsp;</span>
            </p>

            <p>
                <span lang="fi">Ymmärryksen tasot perustuvat SOLO-taksonomiaan: </span>
            </p>

            <p>
                <span lang="fi">Symboli </span>
                <span lang="fi">
                    <img
                        alt="tarvitsee apua ymmärryksen muodostamiseen"
                        width="12"
                        height="12"
                        src="/image005.png"
                    />
                </span>
                <span lang="fi">
                     merkitsee, että opiskelija tarvitsee apua ymmärryksen muodostamiseen
                    opiskeltavasta tutkimusetiikan sisällöstä. Kehittääkseen ymmärrystään
                    tutkimusetiikasta, oppijan on hyvä tutustua esimerkiksi asiaankuuluviin
                    eettisiin ohjeistuksiin ja keskustella kokeneiden tutkijoiden kanssa siitä,
                    miten he ajattelevat oikeiden valintojen tekemistä tutkimuksessa.{' '}
                </span>
            </p>

            <p>
                <span lang="fi">Symboli </span>
                <span lang="EN-GB">
                    <img alt="Orastava ymmärtäminen" width="13" height="13" src="/image006.png" />
                </span>
                <span lang="EN-GB"> </span>
                <span lang="fi">
                    merkitsee orastavan ymmärryksen tasoa. Oppijalla on jonkinlainen käsitys
                    aiheesta, mutta se voi olla yksipuolista. Opiskelijaa kannustetaan ajattelemaan
                    minkälaisia muita ulottuvuuksia tai kysymyksiä aiheeseen voisi liittyä tai jotka
                    voivat seurata opiskelijan esittämästä näkökulmasta. Opiskelijaa voi esimerkiksi
                    kannustaa pohtimaan ketkä tai mitkä tahot ovat osallisia kyseisessä
                    tutkimuseettisessä kysymyksessä ja miten aisa näyttäytyy heidän näkökulmastaan.{' '}
                </span>
            </p>

            <p>
                <span lang="fi">Symboli </span>
                <span lang="fi">
                    <img alt="Asioiden ymmärtäminen" width="17" height="17" src="/image007.png" />
                </span>
                <span lang="fi"> </span>
                <span lang="fi">
                    merkitsee kohtalaisen ymmärryksen tasoa. Oppijalla on ymmärrystä monista
                    aiheeseen liittyvistä seikoista, ja seuraava askel on kehittää ymmärrystä
                    asioiden välisistä yhteyksistä.{' '}
                </span>
            </p>

            <p>
                <span lang="fi">Symboli </span>
                <span lang="fi">
                    <img
                        width="16"
                        height="16"
                        src="/image008.png"
                        alt="Asioiden välisten suhteiden ymmärtäminen"
                    />
                </span>
                <span lang="fi"> </span>
                <span lang="fi">
                    merkitsee asioiden välisten suhteiden ymmärtämistä. Tällä tasolla oppija kykenee
                    soveltamaan tietojaan uusissa tai erilaisissa yhteyksissä ja myös neuvomaan
                    muita.{' '}
                </span>
            </p>

            <p>
                <span lang="fi">Symboli </span>
                <span lang="EN-GB">
                    <img alt="Syvällinen ymmärtäminen" width="19" height="19" src="/image009.png" />
                </span>
                <span lang="EN-GB"> </span>
                <span lang="fi">
                    merkitsee syvällisen ymmärryksen tasoa. Oppija on saattanut ajatella itseään
                    roolimallina ja ymmärtää miten hän omalla toiminnallaan voi edistää
                    tutkimuseettisestä kestävää toimintatapaa.
                </span>
            </p>

            <h3>
                <span lang="fi">Mihin tutkimustietoon sovellus perustuu? </span>
            </h3>

            <p>
                <span lang="fi">
                    Reflektiokompassi pohjautuu tutkimuksellisiin suunnitteluperiaatteisiin ja
                    tutkittuun tietoon. Se hyödyntää
                    <i>Structure of Observed Learning Outcomes</i> (SOLO) -taksonomiaa ymmärryksen
                    tasojen kuvauksessa ja palautteen muotoiluissa. Seuraamalla opiskelijoiden
                    työskentelyä kurssin aikana palautettujen vastausten kautta ja yhdistämällä
                    sovelluksen tehtävistä tuottamaa tietoa ja visualisointeja opettaja voi saada
                    kokonaisvaltaisen kuvan opiskelijoiden kehityksestä ja opetuksen toimivuudesta.
                </span>
            </p>

            <p>
                <span lang="fi">
                    Täältä voit lukea lisää SOLO-taksonomiasta tai sovelluksen taustalla olevasta
                    tutkimuksesta:{' '}
                </span>
            </p>

            <p>
                <span lang="fi">
                    SOLO-taksonomia:{' '}
                    <a href="https://www.johnbiggs.com.au/academic/solo-taxonomy/">
                        https://www.johnbiggs.com.au/academic/solo-taxonomy/
                    </a>
                </span>
            </p>

            <p>
                <span lang="fi">
                    Artikkeli: John Biggs (1999){' '}
                    <a href="https://www.tandfonline.com/doi/pdf/10.1080/0729436990180105">
                        What the Student Does: teaching for enhanced learning
                    </a>
                    , Higher Education Research &amp; Development, 18:1, 57-75, DOI:
                    10.1080/0729436990180105
                </span>
            </p>

            <p>
                <span lang="fi">Tutkimus reflektiosovelluksen kehittämisestä: </span>
            </p>

            <p>
                <span lang="fi">
                    Artikkeli: Anu Tammeleht &amp; Erika Löfström (2024){' '}
                    <a href="https://www.tandfonline.com/doi/pdf/10.1080/10508422.2023.2266073">
                        Learners’ self-assessment as a measure to evaluate the effectiveness of
                        research ethics and integrity training: can we rely on self-reports
                    </a>
                    ?, <i>Ethics &amp; Behavior</i>, 34:8, 575-596, DOI:
                    10.1080/10508422.2023.2266073
                </span>
            </p>

            <p>
                <span lang="fi">Seuraavat tahot ovat tukeneet sovelluksen kehittämistä: </span>
            </p>

            <p>
                <span lang="fi">
                    <img
                        alt="Beyond apples logo"
                        border="0"
                        width="214"
                        height="auto"
                        src="/image011.png"
                    />
                </span>
                <span lang="fi">
                     {' '}
                    <img alt="European union logo" width="117" height="auto" src="/image012.png" />
                       
                </span>
                <span lang="fi">
                    <img
                        border="0"
                        width="200"
                        height="auto"
                        src="/image013.png"
                        alt="Reimagining Teachers and Teacher Education for our Futures | University of  Helsinki"
                    />
                </span>
            </p>
        </div>
    );
};

export default FinnishPage;
